import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {take} from 'rxjs/operators';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {DialogModel} from '@shared/models/dialog.model';
import {Injectable} from '@angular/core';
import {AuditTrackerCommandHandlerBase} from '@features/audit-tracker/services/command-handlers/audit-tracker-command-handler-base';
import {Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {GetSmartGridFieldSectionInfosAction} from '@shared/store/actions/smart-grid.actions';
import {GetFieldSectionsAction} from '@shared/store/actions/virtual-grid.actions';

@Injectable({
  providedIn: 'root',
})
export class RenameAuditStageCommandHandler extends AuditTrackerCommandHandlerBase implements IPlatformCommandHandler {
  constructor( public router: Router,
               private dialogService: DialogService,
               public commandService: CommandService,
               public fuseSplashScreenService: FuseSplashScreenService,
               private queryState: Store<IQueryState>,
               public snackBarService: SnackBarService)  {
    super(router, commandService, fuseSplashScreenService, snackBarService);
  }
  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const dialogModel: DialogModel = DialogModel.create(
      'Rename Current Stage',
      'AddAuditStageDialogComponent',
      {
        stageName: command.fieldValues['StageName'],
      },
      "400px",
      "600px",
      true
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(res => {
      if (res.action === 'OK') {
        console.log('OK button clicked!');
        // parse the values
        command.fieldValues['StageName'] = res.data.input['StageName'];
        command.fieldValues['GridUpdateNeeded'] = true;
        this.executeCommandToApi(command, handler);
    }});
    return true;
  }

  protected onCommandExecuted(command: PlatformCommand, response: any) : void {
    console.log('executing from rename audit stage class');
    const sourceType = command.fieldValues['SourceType'];
    this.queryState.dispatch(new GetSmartGridFieldSectionInfosAction(sourceType));
    this.queryState.dispatch(new GetFieldSectionsAction(sourceType));
  }

}
